exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-sunday.btn-default {background-color: #ccc\n}\n", ""]);

// exports
